import styled, { css, keyframes } from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import {
  QUEUE_FIXED_WIDTH,
  QUEUE_FULL_WIDTH,
} from '@rsos/constants/queueWidths';
import { getCallStatusColor } from './helpers';

export const blink = keyframes`
  50% {
    opacity: 20%;
  }
`;

const notificationBar = css`
  content: '';
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 7px;
  width: 3px;
  height: calc(100% - 10px);
  margin: 5px auto;
  background-color: ${({ theme }) => theme.colors.primaryBase};
  border-radius: 6px;
  animation: ${blink} 1s ease-in-out infinite;
`;

const emergencyCallBg = (isHovered, isSelected) => {
  let backgroundColor = 'background';

  if (isHovered) backgroundColor = 'foreground';
  else if (isSelected) backgroundColor = 'highlights';

  return backgroundColor;
};

export const Container = styled(Box).attrs(
  ({ isExpired, isHovered, isSelected }) => ({
    horizontal: true,
    align: 'center',
    justify: 'space-between',
    position: 'relative',
    width: QUEUE_FIXED_WIDTH,
    minHeight: 70,
    backgroundColor: emergencyCallBg(isHovered, isSelected),
    padding: '8px 24px 8px 22px',
    cursor: 'pointer',
    opacity: isExpired ? 0.4 : 1,
  }),
)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  font-family: 'Roboto', sans-serif;
  user-select: none;
  &:hover {
    background-color: ${({ theme, isSelected }) =>
      !isSelected && theme.colors.foreground};
  }
  &:before {
    ${({ isUnread, isUnseen }) => (isUnread || isUnseen) && notificationBar};
  }
  @media (max-width: ${BP_LAPTOP}px) {
    width: ${QUEUE_FULL_WIDTH};
  }
`;

export const IconBox = styled(Box).attrs({
  flex: '0 0 auto',
  marginRight: 22,
  color: 'secondaryText',
})``;

export const CallBox = styled(Box).attrs({
  flex: '1 1 auto',
  overflow: 'hidden',
})``;

export const PhoneNumber = styled(Text).attrs(({ isUnseen }) => ({
  color: isUnseen ? 'queue.emergencyCall.unseen' : 'primaryText',
  size: 'large',
  fontWeight: 'bold',
}))``;

export const PhoneDetails = styled(Text).attrs({
  marginTop: '4px',
  color: 'secondaryText',
  size: 'small',
  textTransform: 'uppercase',
})``;

// Due to contract with SiriusXM, the text color needs to be 'heavyWarning'.
export const SiriusXMMessage = styled(PhoneDetails).attrs({
  color: 'heavyWarning',
})``;

export const CallStatusTag = styled(Box).attrs(({ status, isCallPopup }) => ({
  width: 'fit-content',
  margin: isCallPopup ? '0 0 5px 0' : '4px 0 5px 0',
  padding: '2px 4px',
  backgroundColor: getCallStatusColor(status, true),
  align: 'center',
  justify: 'center',
}))`
  border-radius: 5px;
`;

export const CallStatus = styled(PhoneDetails).attrs(({ status }) => ({
  marginTop: 0,
  color: getCallStatusColor(status, false),
  fontWeight: 'semibold',
  ellipsis: true,
  lineHeight: 1,
}))``;

export const TextMessage = styled(Text).attrs({
  color: 'secondaryText',
  size: 'small',
  ellipsis: true,
})``;

export const TimeBox = styled(Box).attrs({
  flex: '0 0 auto',
  marginLeft: '10px',
  overflow: 'hidden',
})``;

export const Time = styled(Text).attrs({
  color: 'secondaryText',
  size: 'xsmall',
  textAlign: 'right',
})``;

export const RemoveCall = styled.div`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 10px 15px;
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 2px;
  border-top: ${({ theme }) => `3px solid ${theme.colors.background}`};
  border-bottom: ${({ theme }) => `3px solid ${theme.colors.background}`};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 14px;
  line-height: 1.2;
  text-align: center;
  transition: background-color 0.3s;
  user-select: none;
  &:hover {
    background-color: ${({ theme }) => theme.colors.highlights};
  }
`;
